import React from 'react';
import LiveCodePage from './LiveCodePage';

const LiveCode: React.FC = () => {
  return <LiveCodePage />;
};

export default LiveCode;
